export default function retireLegacyServiceWorker(browserWindow = (
  typeof window === 'undefined' ? null : window
)) {
  if (!browserWindow) return Promise.resolve();

  const serviceWorker = browserWindow.navigator?.serviceWorker;
  const unregister = serviceWorker?.getRegistrations
    ? serviceWorker.getRegistrations()
      .then(registrations => Promise.all(
        registrations.map(registration => registration.unregister()),
      ))
      .catch(() => undefined)
    : Promise.resolve();

  const cacheStorage = browserWindow.caches;
  const clearCaches = cacheStorage?.keys
    ? cacheStorage.keys()
      .then(keys => Promise.all(keys.map(key => cacheStorage.delete(key))))
      .catch(() => undefined)
    : Promise.resolve();

  return Promise.all([unregister, clearCaches]).then(() => undefined);
}
